import React, { useState, useEffect } from 'react';
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";

// DevExtreme components
import { Autocomplete } from 'devextreme-react/autocomplete';

//Redux
import { connect } from "react-redux";

function DirectAccess(props) {
  const { currentDataSegment, currentDataSegmentSessionId, hint, onTaskSelected, currentUILanguageCode } = props;
  const initialWidth = 150;
  const activeWidth = 350;

  const [usertasks, setUserTasks] = useState([]);
  const [currentValue, setCurrentValue] = useState(null);
  const [controlWidth, setControlWidth] = useState(initialWidth);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        console.log("GetUserTasks for session " + currentDataSegmentSessionId)
        let result = await BosWebGuiServices.fetchGetUserTasks(currentDataSegment.authToken, currentDataSegmentSessionId, currentDataSegment.id);
        console.log("GetUserTasks for DataSegmentId " + currentDataSegment.id + " result:", result);
        setUserTasks(onlyTasks(result));
        setError(false);
      } catch (error) {
        console.error("UserTasks for DataSegmentId " + currentDataSegment.id + " error:", error);
        setUserTasks();
        setError(true);
      }
    }

    if (currentDataSegment && currentDataSegmentSessionId) fetchData();
    else setUserTasks();

  }, [currentDataSegment, currentDataSegmentSessionId, currentUILanguageCode, refreshTrigger]);

  const selectionChanged = (value) => {
    if (value && value.selectedItem && value.selectedItem.taskId) {
      onTaskSelected(value.selectedItem.targetUri);
    }
  };

  const valueChanged = (args) => {
    setCurrentValue(args.event ? args.value : null);
  };

  const focusChanged = (focusIn) => {
    setControlWidth(focusIn ? activeWidth : initialWidth);
    if (focusIn) setRefreshTrigger(prev => prev + 1);
    setCurrentValue();
  };

  const onlyTasks = (taskgroups) => {
    let result = [];
    (taskgroups || []).forEach(tg => {
      if (tg.tasks) result = [...result, ...tg.tasks];
      if (tg.subGroups) result = [...result, ...onlyTasks(tg.subGroups)]
    });
    return result;
  };

  return (
    <Autocomplete
      hint={hint}
      disabled={error}
      dataSource={usertasks}
      valueExpr="name"
      searchExpr="name"
      searchMode="startswith"
      displayValue="name"
      onValueChanged={e => valueChanged(e)}
      onSelectionChanged={e => selectionChanged(e)}
      onFocusIn={() => focusChanged(true)}
      onFocusOut={() => focusChanged(false)}
      value={currentValue}
      height="2em"
      width={controlWidth}
    />
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
  };
}

export default connect(mapStateToProps)(DirectAccess);